import React from 'react'
import { IconProps } from '../../types/types'

const MobileIcon: React.FC<IconProps> = ({ size = '16', color = '#003366' }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.668 14.6654H6.0013C4.0013 14.6654 2.66797 13.332 2.66797 11.332V4.66536C2.66797 2.66536 4.0013 1.33203 6.0013 1.33203H10.668C12.668 1.33203 14.0013 2.66536 14.0013 4.66536V11.332C14.0013 13.332 12.668 14.6654 10.668 14.6654Z" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M2.66797 10H14.0013" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.66797 8H5.33464" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.66797 6.33203H5.33464" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M4.66797 4.66797H5.33464" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10.9976 12.1654H11.0036" stroke={color} stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default MobileIcon